import { render, staticRenderFns } from "./GatewayLogCom.vue?vue&type=template&id=482d751c&"
import script from "./GatewayLogCom.vue?vue&type=script&lang=ts&"
export * from "./GatewayLogCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports